import { mapGetters } from "vuex";
import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { ITermsAndConditions } from "@/models/termsAndConditions";
import { MD5 } from "object-hash";
import { DataModules } from "@/store/modules/data";
import { IBrand } from "@/models/brands";
@Component({
  computed: {
    ...mapGetters({
      brandId: "brand/id"
    })
  }
})
export default class TermsAndConditionsMixin extends Mixins(RequestPromises) {
  @Prop({ required: false, default: "current" })
  public termsId!: string;

  public current: ITermsAndConditions | null = null;

  public tAndC: ITermsAndConditions = {
    terms: {
      terms: "",
      url: ""
    }
  } as ITermsAndConditions;

  public isUrl = false;
  public loading = false;
  public brandId!: IBrand["id"];
  public data!: any;

  public get hasChange() {
    const hash1 = MD5(this.current);
    const hash2 = MD5(this.tAndC);
    return hash1 !== hash2;
  }

  public get canCreateTermsAndConditions() {
    return this.$userCan("create_terms_and_conditions");
  }

  public created() {
    this.loadData();
  }

  // Methods
  public loadData() {
    this.loading = true;
    this.getTermsAndConditions();
  }

  public create() {
    const data: any = {
      name: this.tAndC.terms.name
    };

    if (this.isUrl) {
      data.url = this.tAndC.terms.url;
      this.tAndC.terms.url = "";
    } else {
      data.terms = this.tAndC.terms.terms;
      this.tAndC.terms.terms = "";
    }

    return this.$store
      .dispatch(`data/${DataModules.TERMS_AND_CONDITIONS}/create`, {
        data
      })
      .then(() => {
        this.$emit("save");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      });
  }

  public async getTermsAndConditions() {
    try {
      const data = await this.$store.dispatch(
        `data/${DataModules.TERMS_AND_CONDITIONS}/get`,
        {
          id: this.termsId,
          vm: this,
          storeData: false
        }
      );
      this.data = data;
      this.current = data;
      this.tAndC = this.$_.merge({}, this.tAndC, this.current);
      this.isUrl = !!this.tAndC.terms.url;
    } catch (error) {
      if (this.$_.get(error, "response.status") !== 404) {
        // Mask error when current is not found
        this.$store.dispatch("api/handleError", error);
      }
    } finally {
      this.loading = false;
    }
  }

  public revertToInitialState() {
    this.current = this.data;
    this.tAndC = this.$_.merge({}, this.tAndC, this.current);
    this.isUrl = !!this.tAndC.terms.url;
  }
}
